<template>
  <div class="checkbox-container" @click="toggleCheck">
    <div class="checkbox" :class="{ checked: isChecked }">
      <svg v-if="isChecked" width="13.333984" height="10.000000" viewBox="0 0 13.334 10" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs/>
          <path id="Vector" d="M5 7.64L12.22 0L13.33 1.17L5 10L0 4.7L1.11 3.52L5 7.64Z" fill="#050505" fill-opacity="1.000000" fill-rule="nonzero"/>
      </svg>

    </div>
    <label>Remember me</label>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isChecked: false,
    };
  },
  methods: {
    toggleCheck() {
      this.isChecked = !this.isChecked;
    },
  },
};
</script>

<style scoped>
.checkbox-container {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 12px;
}

.checkbox {
  width: 24px;
  height: 24px;
  border: 2px solid #f7b500;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s;
}

.checkbox.checked {
  background-color: #f7b500;
}
label{
  color: rgb(85, 98, 114);
  font-size: 13px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: left;
}
</style>
